import Snackbar from "@material-ui/core/Snackbar";
import { makeStyles } from "@material-ui/core/styles";
import MuiAlert from "@material-ui/lab/Alert";
import React from "react";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2)
    }
  }
}));

export default function CustomizedSnackbars({ open, exito, handleClose }) {
  const classes = useStyles();
  /*const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  }; 

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };*/

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        {exito ? (
          <Alert onClose={handleClose} severity="success">
            Creado Existosamente!
          </Alert>
        ) : (
          <Alert onClose={handleClose} severity="error">
            Ha Ocurrido un Error!
          </Alert>
        )}
      </Snackbar>
      {/*<Alert severity="error">This is an error message!</Alert>*/}
    </div>
  );
}
